/*
 * @Descripttion:
 * @Author: etong
 * @Date: 2021-12-28 13:37:59
 * @LastEditors: your name
 * @LastEditTime: 2022-07-01 16:34:44
 */
// 商丘事务
const map = {
  sqReturnRequestList: () => import('@/views/sqAffairs/sqReturnRequestList'), // 退货申请
  returnRequestList: () => import('@/views/sqAffairs/returnRequestList'), // 退货申请
  receivingSupplementList: () => import('@/views/sqAffairs/receivingSupplementList'), // 收货补单通知
  packageRegistrationList: () => import('@/views/sqAffairs/packageRegistrationList'), // 已登记待入库通知
  stockTransferOrderList: () => import('@/views/sqAffairs/StockTransferOrderList'), // 调拨单管理
  cancelExpressageNotify: () => import('@/views/sqAffairs/CancelExpressageNotify'), // 拦截|回退通知
  abnormalPackageOrder: () => import('@/views/sqAffairs/AbnormalPackageOrderTableList'), // 物流退费通知
  tkabnormalOrder: () => import('@/views/sqAffairs/TkabnormalOrder') // TK异常单处理
}

export default map

